import React from 'react'
import AgentSalesView from '../components/dashboard/AgentSalesView'

const PlusAgentSalesPage = () => (
  <AgentSalesView
    operator="plus"
    title="Plus — Sprzedaż per Agent"
    description="Agregacja sprzedaży per firma agencyjna (APS) z drill-down do salonów i kontaktów RKS. Eksport Excel jest podstawą pod automatyczną wysyłkę raportów (Phase 2)."
  />
)

export default PlusAgentSalesPage
